<template>
    <div style="align-items: center; padding: 20px">
        <div style="align-items: center;" class="text-center mb-10">
            <img style="width: 250px;height: auto;border-radius: 2px;" src="../../../public/images/logo_muic.png"
                alt="imag_voteJob_1" />
        </div>
        <a-row :gutter="[24, 24]" justify="space-around" align="middle" class="mt-5">
            <!-- Detail -->
            <a-col :span="24" :xl="{ span: 18, offset: 2 }" :sm="{ span: 24 }" class="col-form">
                <a-row>
                    <a-col :span="24">
                        <h5 class="font-web mb-0">MUIC SERVICE</h5>
                        <p class="font-web text-muted font-weight-bold">
                            Vote : {{ getTokenUrl }}
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mb-20">
                    <a-col :span="24">
                        <a-card style="background-color: #424769; border-radius: 10px" class="mt-10 mb-10" hoverable>
                            <template slot="actions" class="ant-card-actions"></template>

                            <div class="text-left">
                                <h6 class="m-0 text-warning font-web">Toppic : {{ itemJobDetail[0].topic }}</h6>
                                <h6 class="m-0 text-warning font-web">Your Query No : {{ itemJobDetail[0].id }}</h6>
                            </div>

                            <a-card-meta>
                                <template slot="title">
                                    <div class="text-left">
                                        <hr>
                                        <h6 class="text-white mt-0 mb-10 font-web">
                                            รายละเอียด :: {{ itemJobDetail[0].ticket_type_detail }}
                                        </h6>
                                    </div>
                                </template>
                                <div class="pa-10" slot="description">

                                    <!--  -->
                                    <div v-for="(msgs, index) in itemJobDetail[0].msg_detail" :key="index">
                                        <div class="mb-10 font-web text-white"
                                            :class="{ 'text-right': itemJobDetail[0].user !== msgs.user }">
                                            <p class="mb-0 f-user font-web text-white">แจ้งโดย : {{ msgs.user }}</p>
                                            <small class="font-web text-white">{{ moment(msgs.created_at).format('LLL')
                                            }}</small>
                                            <hr class="mb-5 mt-10">
                                            <p style="font-size:0.7rem;" class="text-grey mt-10 mb-0 font-web">>> Comment
                                            </p>
                                            <p class="mt-5 mb-5 font-web text-white">
                                                {{ msgs.message }}
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </a-card-meta>
                        </a-card>

                        <div v-if="[null, 'null'].includes(checkVote)">
                            <div class="mt-15 mb-5 text-left">
                                <h6 class="font-web text-dark font-bold mt-50 mb-0">
                                    <a-icon type="edit" class="mr-10" />Point = {{ value }}
                                </h6>
                                <a-rate style="font-size: 50px" v-model="value" />
                            </div>

                            <h6 class="font-web text-dark font-bold mt-20 mb-15">
                                <a-icon type="edit" class="mr-10" />Suggestion (if any)
                            </h6>

                            <a-textarea placeholder="" v-model="suggestion" :auto-size="{ minRows: 3, maxRows: 5 }" />

                            <a-button @click="addVoteTicket" class="mt-20 mb-30 font-web" type="primary" block>
                                Vote / close
                            </a-button>
                        </div>
                        <div v-else>
                            <a-alert 
                                message="Success Tips"
                                description="For rating Your suggestion, we will continue to improve the service." type="success"
                                show-icon />
                            <a-button @click="() => {
                                this.$router.push('/').catch(err => { })
                            }" class="mt-20 mb-30 font-web" type="primary" block>
                                GO TO MY MUIC
                            </a-button>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <!-- / Detail -->
        </a-row>
    </div>
</template>
  
<script>
const columns = [];
export default {
    components: {},
    data() {
        return {
            suggestion: null,
            msgTokenError: '',
            itemJobDetail: [],
            checkVote: null,
            value: 0,
        }
    },
    computed: {
        getTokenUrl() {
            return this.$route.query.token === undefined || this.$route.query.token === "" ? this.$router.push('/errortokenpage').catch(err => { }) : this.$route.query.token
        },
    },
    mounted() {
        this.callDetailJob()
    },
    methods: {
        async callDetailJob() {
            this.itemJobDetail = []
            this.msgTokenError = ''
            this.checkVote = null
            try {
                const res = await this.$http.get(`/ticket/mail_content/?token=${this.getTokenUrl}`)
                if (res.status === 200) {
                    this.checkVote = res.data.ticketpoint
                    this.itemJobDetail.push(res.data)
                } else {
                    const error = new Error('Request Failed');
                    error.response = res; // Mapping for catch block compatibility if needed, though catch helper relies on structure
                    error.res = res; // Adding res as property if specific catch logic uses it
                    throw error;
                }
            } catch (error) {
                this.msgTokenError = 'errorGetToken'
                this.checkVote = null
                this.$router.push('/errortokenpage').catch(err => { })
            }
        },
        async addVoteTicket() {
            this.msgTokenError = ''
            try {
                const sendVote = new FormData()
                sendVote.append('token', this.getTokenUrl)
                sendVote.append('ticketcomment', this.suggestion)
                sendVote.append('ticketpoint', this.value)
                const resVote = await this.$http.patch(`/ticket/mail_vote/`, sendVote, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                if (resVote.status === 200) {
                    this.callDetailJob()
                } else {
                    const error = new Error('Request Failed');
                    error.resVote = resVote;
                    throw error;
                }
            } catch (error) { }
        }
    }
};
</script>
  
<style scoped>
.img-size-lock {
    width: 250px;
    height: 300px;
}

.logo-size {
    width: 295px;
    height: 100px;
    margin-top: 25px;
    z-index: -999;
}

.example {
    text-align: center;
    background: #60d5ff4d;
    border-radius: 4px;

    padding: 30px 50px;
    margin: 20px 0;
}

.f-16 {
    font-size: 14px;
}

.f-12 {
    font-size: 12px;
}
</style>